import { instance } from "./apiClient";

export const expensesApi = {
  getExpenses: ({ listId, page, month, useMonth, search }) => {
    let urlParams = `?page=${page}`;
    if (useMonth) urlParams += `&month=${month}`;
    if (search) urlParams += `&search=${encodeURIComponent(search)}`;
    return instance
      .get(`/api/expenses_lists/${listId}/expenses${urlParams}`)
      .then((res) => res.data);
  },

  deleteExpense: ({ listId, expenseId, month, useMonth }) => {
    let urlParams = useMonth ? `?month=${month}` : "";
    return instance
      .delete(`/api/expenses_lists/${listId}/expenses/${expenseId}${urlParams}`)
      .then((res) => res.data);
  },

  updateExpense: ({ listId, expenseId, payload, month, useMonth }) => {
    let urlParams = useMonth ? `?month=${month}` : "";
    return instance
      .put(
        `/api/expenses_lists/${listId}/expenses/${expenseId}${urlParams}`,
        payload
      )
      .then((res) => res.data);
  },

  createExpense: ({ listId, payload }) =>
    instance
      .post(`/api/expenses_lists/${listId}/expenses`, payload)
      .then((res) => res.data),

  getExpensesChartData: ({ listId, month, kind }) =>
    instance
      .get(
        `/api/expenses_lists/${listId}/chart_data?kind=${kind}&month=${month}`
      )
      .then((res) => res.data),
};
